import { Box, Grid, Typography } from "@mui/material";
import { RestaurantHeader } from "../MenuLuxPos/RestaurantHeader";
import RestaurantSidebar from "../MenuLuxPos/RestaurantSidebar";
import OrderDetails from "../MenuLuxPos/OrderDetails";
import { MenuItemCard } from "../MenuLuxPos/MenuItemCard";
import RightSidebar from "../MenuLuxPos/Menubar";

export const MainLayout: React.FC<{ selectedMenu: string, handleMenuSelect: (menu: string) => void }> = ({ selectedMenu, handleMenuSelect }) => {
    return (
      <Grid sx={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
        {/* Header */}
        <Grid sx={{ flexShrink: 0 }}>
          <RestaurantHeader />
        </Grid>
  
        {/* Main Content */}
        <Grid sx={{ display: 'flex', flexGrow: 1 }}>
          {/* Sidebar */}
          <Grid sx={{  minWidth: '100px', backgroundColor: '#9c27b0', color: '#fff', }}>
            <RestaurantSidebar />
          </Grid>
  
          {/* Order Details */}
          <Grid sx={{ flexGrow: 1, width: '40rem', minWidth: '100px' }}>
            <OrderDetails />
          </Grid>
  
          <Grid sx={{ flexGrow: 1, padding: 2 }}>
            <Typography variant="h6" gutterBottom>
              {selectedMenu} {/* Display the selected path */}
            </Typography>
            <MenuItemCard />
          </Grid>
  
          {/* Right Sidebar */}
          <Grid sx={{ flexGrow: 1 }}>
            <RightSidebar onMenuSelect={handleMenuSelect} />
          </Grid>
        </Grid>
      </Grid>
    );
  };